import { EMERALD_CITY_PRODUCT } from "@constants/images";
import Button from "@components/common/Button.component";
import { useNavigate } from "react-router-dom";

const CrownToken = () => {
  const navigate = useNavigate();
  return (
    <div className="crownToken-wrapper">
      <div className="crownToken">
        <div className="crownToken-info">
          <h4 className="crownToken-heading">CROWN Token</h4>
          <p className="crownToken-paragraph adjust-font">
            The GangstaVerse Crown ($CROWN) is the governance token for the
            Emerald City in GangstaVerse will be used to fuel the entire economy of the City. It
            will be used as a currency and reward for various in-game activities
            in the ICON Emerald City.
          </p>

          <p className="crownToken-paragraph adjust-font"> 
            The total supply of GangstaVerse Crown ($CROWN) will be 250 million tokens.
          </p>
          <Button onClick={() => window.open("https://docs.gangstabet.io/gangstaverse/crown-token")}>
            Learn More
          </Button>

        </div>
        <div className="spinner-wrapper">
          <img
            className="spinner"
            src={EMERALD_CITY_PRODUCT.SPINNER}
            alt="crown logo"
          />
          <img
            className="crown"
            src={EMERALD_CITY_PRODUCT.CROWN}
            alt="crown logo"
          />
        </div>
      </div>
    </div>
  );
};

export default CrownToken;
